const o = {
  id: "OhioRollingCash5",
  logo: !0,
  name: "Rolling Cash 5",
  style: {
    colorPrimary: "#71bc4c"
  }
};
export {
  o as default
};
